import request from '@/plugins/axios'

/** S 商城列表 **/
// 商城列表
export const apiShopLists = (params: any) => request.get('/shop.shop/lists', {params})

// 添加商城
export const apiShopAdd = (params: any) => request.post('/shop.shop/add', params)

// 商城详情
export const apiShopDetail = (params: any) => request.get('/shop.shop/detail', {params})

// 编辑商城
export const apiShopEdit = (params: any) => request.post('/shop.shop/edit', params)

// 删除商城
export const apiShopDelete = (params: any) => request.post('/shop.shop/delete', params)

// 指纹独立站店铺列表
export const apiZwStoreLists = () => request.get('/shop.zw_store/storeLists')
export const apiZwAsyncLists = (params: any) => request.get('/shop.zw_store/lists', {params})
export const apiZwStoreCategoryLists = () => request.get('/shop.zw_store/categoryLists')

//获取独立站店铺详情
export const apiZwStoreDetail = (params: any) => request.get('/shop.zw_store/detail', {params})

// 添加指纹独立站店铺
export const apiZwStoreAdd = (params: any) => request.post('/shop.zw_store/add', params)

// 编辑指纹独立站店铺
export const apiZwStoreEdit = (params: any) => request.post('/shop.zw_store/edit', params)

export const apiSetSuperShop = (params: any) => request.post('/shop.shop/setSuperShop', params)

//同步指纹店铺商品
export const apiAsyncStoreProducts = (params: any) => request.post('/shop.zw_store/asyncStoreProducts', params)
export const apiAsyncCost = (params: any) => request.post('/shop.zw_store/asyncCost', params)
export const apiGetAsyncMsg = (params: any) => request.get('/shop.zw_store/getAsyncMsg', {params})

// 修改超级管理员
export const apiShopChangeSuperAdmin = (params: any) => request.post('/shop.shop/changeSuperAdmin', params)

// 修改商城状态
export const apiShopSwitchStatus = (params: any) => request.post('/shop.shop/switchStatus', params)
export const apiShopChangeAmount = (params: any) => request.post('/shop.shop/changeAmount', params)

export const apiAsyncOwner = (params: any) => request.get('/shop.shop/asyncOwner', {params})

// 历史套餐
export const apisetMealLogLists = (params: any) => request.get('/shop.shop/setMealLogLists', {params})

// 修改商城备注
export const apiChangeRemark = (params: any) => request.post('/shop.shop/changeRemark', params)
/** E 商城列表 **/

/** S 套餐列表 **/
// 套餐列表
export const apiSetMealLists = (params: any) => request.get('/shop.set_meal/lists', {params})

// 添加套餐
export const apiSetMealAdd = (params: any) => request.post('/shop.set_meal/add', params)

// 套餐详情
export const apiSetMealDetail = (params: any) => request.get('/shop.set_meal/detail', {params})

// 编辑套餐
export const apiSetMealEdit = (params: any) => request.post('/shop.set_meal/edit', params)

// 删除套餐
export const apiSetMealDelete = (params: any) => request.post('/shop.set_meal/del', params)

// 修改套餐状态
export const apiSetMealSwitchStatus = (params: any) => request.post('/shop.set_meal/status', params)

export const apiMealModule = () => request.get('/shop.set_meal/getMealModule')
/** E 套餐列表 **/

